;(function(){
  "use strict"

  window.Market.config.app = {
    env: 'development' // 'development' || 'production'
  }

})();
